
interface IUIStaticStore {
    icons: any;
}

// initial state
const UIState: IUIStaticStore = {
    icons: {
        i91: '$vuetify.icons.path',
        i92: '$vuetify.icons.claim',
        i93: '$vuetify.icons.commentOval',
        i999: 'cached',
    }
};

// getters
const getters = {
    getIcon: (state: IUIStaticStore) => (iconId: string) => state.icons[iconId],
};

// mutations
const mutations = {
};

// actions
const actions = {
};

export default {
    state: UIState,
    getters,
    actions,
    mutations,
};
